import { observer } from 'mobx-react'
import { useContext } from 'react'
import { StoreContext } from '@store/Root.store'
import {
  TermsAndConditions,
  AdditionalParagraphProps,
} from '@components/TermsAndConditions/TermsAndConditions'

const AdditionalParagraph: React.FC<AdditionalParagraphProps> = ({ tabIndex, theme, trans }) => (
  <>
    <p className="generic__intro-paragraph">
      {trans?.descriptionPartOne}
      <a
        className="generic__link"
        href="https://eidas.ec.europa.eu/efda/tl-browser/#/screen/tl/ES/42"
        target="_blank"
        rel="noreferrer"
        tabIndex={tabIndex}
      >
        {trans?.serviceProvider}
      </a>
    </p>

    <div className="ikano__logo-divider" />
  </>
)

export const TermsAndConditionsWithMicropaymentIkanoPage = observer(() => {
  const store = useContext(StoreContext)
  const { welcomePage: trans } = store.TranslationsState.translationsNew

  return (
    <TermsAndConditions
      header={trans.header}
      showRequired={false}
      AdditionalParagraph={AdditionalParagraph}
      additionalParagraphProps={{ trans: trans }}
    />
  )
})
